import { createContext } from "react";
export const scoreContext = createContext({});
